import { render, staticRenderFns } from "./CropDetails.vue?vue&type=template&id=55435ec2&"
import script from "./CropDetails.vue?vue&type=script&lang=js&"
export * from "./CropDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports